// Theme definitions for Wanderer's Wallet
// Premium users can switch between these themes

export const themes = {
  // Default - Current Cobalt/Slate theme (FREE)
  default: {
    id: 'default',
    name: 'Slate Wanderer',
    description: 'Clean and professional dark theme',
    isPremium: false,
    isLocked: false,
    price: 0,
    colors: {
      background: '#1A1F2E',
      foreground: '#F5F3EE',
      card: '#252B3B',
      cardForeground: '#F5F3EE',
      primary: '#0052CC',
      primaryForeground: '#FFFFFF',
      secondary: '#3A4357',
      secondaryForeground: '#F5F3EE',
      muted: '#3A4357',
      mutedForeground: '#8B95A5',
      accent: '#6B8F71',
      accentForeground: '#F8F6F1',
      destructive: '#C17767',
      border: '#3A4357',
      ring: '#0052CC',
    },
    backgroundImage: null,
    fontStyle: 'default',
  },

  // Fantasy Realm - For the adventurer
  fantasy: {
    id: 'fantasy',
    name: 'Fantasy Realm',
    description: 'An ancient ledger from a dragon-filled realm of mountains and magic',
    isPremium: true,
    isLocked: false,
    price: 0,
    colors: {
      background: '#1C1410',
      foreground: '#E8D5B5',
      card: 'rgba(42, 31, 24, 0.85)',
      cardForeground: '#E8D5B5',
      primary: '#D4A44C',
      primaryForeground: '#1C1410',
      secondary: 'rgba(61, 46, 35, 0.8)',
      secondaryForeground: '#E8D5B5',
      muted: 'rgba(61, 46, 35, 0.8)',
      mutedForeground: '#A89078',
      accent: '#8B6914',
      accentForeground: '#E8D5B5',
      destructive: '#8B3A3A',
      border: '#5A4332',
      ring: '#D4A44C',
    },
    backgroundImage: 'url(https://static.prod-images.emergentagent.com/jobs/5fd95f09-5013-4d44-8e41-38282d85c0ec/images/730c817cc8d4b7ecd9582ea4304292e5e7eb9aa0b7ced77af0361045100a3c59.png)',
    backgroundStyle: {
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
    },
    fontStyle: 'fantasy',
  },

  // Cyberpunk - For the tech-savvy nerd
  cyberpunk: {
    id: 'cyberpunk',
    name: 'Neon City',
    description: 'Rain-soaked streets and neon lights of a futuristic metropolis',
    isPremium: true,
    isLocked: false,
    price: 0,
    colors: {
      background: '#0A0515',
      foreground: '#E0E0E0',
      card: 'rgba(26, 10, 46, 0.85)',
      cardForeground: '#E0E0E0',
      primary: '#FF00FF',
      primaryForeground: '#0A0515',
      secondary: 'rgba(45, 27, 78, 0.8)',
      secondaryForeground: '#E0E0E0',
      muted: 'rgba(45, 27, 78, 0.8)',
      mutedForeground: '#8B7BA8',
      accent: '#00FFFF',
      accentForeground: '#0A0515',
      destructive: '#FF3366',
      border: '#6B3FA0',
      ring: '#FF00FF',
    },
    backgroundImage: 'url(https://static.prod-images.emergentagent.com/jobs/5fd95f09-5013-4d44-8e41-38282d85c0ec/images/c8212ed486c32ef7fa1cff4ac224f80263fc3938548c51ab93ae2de3a4c20931.png)',
    backgroundStyle: {
      backgroundSize: 'cover',
      backgroundPosition: 'center top',
      backgroundAttachment: 'fixed',
    },
    fontStyle: 'cyberpunk',
  },

  // Steampunk - Victorian industrial aesthetic
  steampunk: {
    id: 'steampunk',
    name: 'Steampunk Express',
    description: 'Brass gears and Victorian elegance for the refined traveler',
    isPremium: true,
    isLocked: false,
    price: 0,
    colors: {
      background: '#1A1611',
      foreground: '#E8DFD0',
      card: '#2C2318',
      cardForeground: '#E8DFD0',
      primary: '#B87333',
      primaryForeground: '#1A1611',
      secondary: '#3E3227',
      secondaryForeground: '#E8DFD0',
      muted: '#3E3227',
      mutedForeground: '#9C8B78',
      accent: '#8B7355',
      accentForeground: '#E8DFD0',
      destructive: '#8B4513',
      border: '#5C4A3A',
      ring: '#B87333',
    },
    backgroundImage: 'linear-gradient(135deg, #1A1611 0%, #2C2318 50%, #1A1611 100%)',
    fontStyle: 'steampunk',
  },

  // Ocean Voyager - For the sea-loving traveler
  ocean: {
    id: 'ocean',
    name: 'Ocean Voyager',
    description: 'Dive into the depths with calming ocean blues',
    isPremium: true,
    isLocked: false,
    price: 0,
    colors: {
      background: '#0A1628',
      foreground: '#E6F0F5',
      card: '#122640',
      cardForeground: '#E6F0F5',
      primary: '#00A3CC',
      primaryForeground: '#FFFFFF',
      secondary: '#1A3A5C',
      secondaryForeground: '#E6F0F5',
      muted: '#1A3A5C',
      mutedForeground: '#7BA3BD',
      accent: '#20B2AA',
      accentForeground: '#0A1628',
      destructive: '#E74C3C',
      border: '#2A4A6C',
      ring: '#00A3CC',
    },
    backgroundImage: 'linear-gradient(180deg, #0A1628 0%, #122640 50%, #0A1628 100%)',
    fontStyle: 'default',
  },

  // Minimalist Light - Clean daytime theme
  light: {
    id: 'light',
    name: 'Minimalist Light',
    description: 'Clean and bright for daytime budget tracking',
    isPremium: true,
    isLocked: false,
    price: 0,
    colors: {
      background: '#FAFAFA',
      foreground: '#1A1A1A',
      card: '#FFFFFF',
      cardForeground: '#1A1A1A',
      primary: '#0052CC',
      primaryForeground: '#FFFFFF',
      secondary: '#F0F0F0',
      secondaryForeground: '#1A1A1A',
      muted: '#F0F0F0',
      mutedForeground: '#6B7280',
      accent: '#10B981',
      accentForeground: '#FFFFFF',
      destructive: '#EF4444',
      border: '#E5E5E5',
      ring: '#0052CC',
    },
    backgroundImage: null,
    fontStyle: 'default',
  },

  // Future IAP themes (locked by default)
  aurora: {
    id: 'aurora',
    name: 'Northern Aurora',
    description: 'Dance with the northern lights',
    isPremium: true,
    isLocked: true,
    price: 0.99,
    colors: {
      background: '#0B1426',
      foreground: '#E8F4F8',
      card: '#132238',
      cardForeground: '#E8F4F8',
      primary: '#00D9A5',
      primaryForeground: '#0B1426',
      secondary: '#1E3A5F',
      secondaryForeground: '#E8F4F8',
      muted: '#1E3A5F',
      mutedForeground: '#7EB8C9',
      accent: '#A855F7',
      accentForeground: '#FFFFFF',
      destructive: '#F43F5E',
      border: '#2E4A6F',
      ring: '#00D9A5',
    },
    backgroundImage: 'linear-gradient(135deg, #0B1426 0%, #1E3A5F 50%, #132238 100%)',
    fontStyle: 'default',
  },

  sunset: {
    id: 'sunset',
    name: 'Desert Sunset',
    description: 'Warm hues of a traveler\'s sunset',
    isPremium: true,
    isLocked: true,
    price: 0.99,
    colors: {
      background: '#1A1114',
      foreground: '#F5E6E0',
      card: '#2D1D22',
      cardForeground: '#F5E6E0',
      primary: '#F97316',
      primaryForeground: '#FFFFFF',
      secondary: '#3D2830',
      secondaryForeground: '#F5E6E0',
      muted: '#3D2830',
      mutedForeground: '#B89A92',
      accent: '#EAB308',
      accentForeground: '#1A1114',
      destructive: '#DC2626',
      border: '#4D3840',
      ring: '#F97316',
    },
    backgroundImage: 'linear-gradient(180deg, #1A1114 0%, #2D1D22 50%, #1A1114 100%)',
    fontStyle: 'default',
  },
};

// Get theme by ID
export const getTheme = (themeId) => {
  return themes[themeId] || themes.default;
};

// Get all available themes
export const getAllThemes = () => {
  return Object.values(themes);
};

// Get premium themes only
export const getPremiumThemes = () => {
  return Object.values(themes).filter(t => t.isPremium);
};

// Get unlocked themes (free + premium unlocked)
export const getUnlockedThemes = (isPremium) => {
  return Object.values(themes).filter(t => !t.isLocked && (!t.isPremium || isPremium));
};

// Get locked themes (for IAP)
export const getLockedThemes = () => {
  return Object.values(themes).filter(t => t.isLocked);
};

// Apply theme to document
export const applyTheme = (themeId) => {
  const theme = getTheme(themeId);
  const root = document.documentElement;
  
  // Apply all color variables
  Object.entries(theme.colors).forEach(([key, value]) => {
    const cssVarName = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
    root.style.setProperty(cssVarName, value);
  });
  
  // Apply background
  if (theme.backgroundImage) {
    document.body.style.backgroundImage = theme.backgroundImage;
    
    // Apply additional background styles if defined
    if (theme.backgroundStyle) {
      Object.entries(theme.backgroundStyle).forEach(([prop, value]) => {
        document.body.style[prop] = value;
      });
    } else {
      // Default background styles for gradient backgrounds
      document.body.style.backgroundSize = 'cover';
      document.body.style.backgroundPosition = 'center';
      document.body.style.backgroundAttachment = 'fixed';
    }
  } else {
    document.body.style.backgroundImage = 'none';
    document.body.style.backgroundColor = theme.colors.background;
    document.body.style.backgroundSize = 'auto';
    document.body.style.backgroundPosition = 'initial';
    document.body.style.backgroundAttachment = 'scroll';
  }
  
  // Apply font style class
  document.body.className = document.body.className
    .replace(/theme-font-\w+/g, '')
    .trim();
  if (theme.fontStyle !== 'default') {
    document.body.classList.add(`theme-font-${theme.fontStyle}`);
  }
  
  // Store theme preference
  localStorage.setItem('wanderers-wallet-theme', themeId);
};

// Get saved theme or default
export const getSavedTheme = () => {
  return localStorage.getItem('wanderers-wallet-theme') || 'default';
};
